import { RestClient } from '@/modules/axios';

export default {
    state: {
        selectSheetClientModule: null,
    },
    actions: {
        postSelectedSheet({ dispatch }, payload) {
            return dispatch('getSelectSheetClientModule').then((sheetpost) => {
                return sheetpost
                    .post('/api/selectsheet', payload)
                    .then(() => {
                        return Promise.resolve();
                    })
                    .catch(() => {
                        return Promise.reject();
                    });
            });
        },

        getSelectSheetClientModule(context) {
            if (!context.state.selectSheetClientModule) {
                context.state.selectSheetClientModule = new RestClient('', context);
            }
            return context.state.selectSheetClientModule;
        },
    },
};
